export async function afterRegistration ({ store, isServer }) {
  if (isServer) return
  store.dispatch('recommended/initialize')
}